/**
 * @param {Date} inputDate 
 * @returns {string} Date in format "MMMM dd, yyyy"
 */
 const formatPublicationDate = (inputDate) => {
    const monthName = inputDate.toLocaleDateString('default', { month: "long" });
    const dayInMonth = inputDate.getDate();
    const year = inputDate.getFullYear();

    return `${monthName} ${dayInMonth}, ${year}`;
};

export { formatPublicationDate };
